import React from 'react';
import { View, Text, FlatList, RefreshControl } from 'react-native';
import { connect } from 'react-redux';

import Colors from "../../constants/Colors";
import WritePostButton from "../mural/WritePostButton";
import get from "../../api/methods/get";
import {QUERY_TOPICS} from "./api/forumEndpoints";
import TopicRender from "./topic/TopicRender";
import {Card, CardTextArrow, ConditionalTextRender, SpinnerControl} from "../../components";
import NavBar from "../../components/NavBar";

class ForumScreen extends React.Component {

    state = {
        isFetchingTopics: false,
        topics: []
    }

    queryTopics = async () => {
        if (this.state.isFetchingTopics) return;
        this.setState({ isFetchingTopics: true });

        try {
            const queryResult = await get(QUERY_TOPICS(this.props.journeyId));
            const json = await queryResult.json();

            this.setState({ topics: json.data.Items })

        } catch (e) {
            console.log(e)
        }

        this.setState({ isFetchingTopics: false });
    }

    componentDidMount() {
        this.queryTopics();
    }

    render() {
        return (
            <NavBar title={"Fórum"}>

                <SpinnerControl
                    isFetching={this.state.isFetchingTopics}
                    text={"Carregando tópicos"}
                />

                {
                    this.state.isFetchingTopics === false &&
                        <CardTextArrow
                            text={"Criar novo tópico"}
                            showArrow={true}
                            onPress={() => this.props.history.push('/forum/topic/create')}
                        />
                }

                {
                    (this.state.topics.length === 0 && this.state.isFetchingTopics === false) &&
                        <Text style={{ fontSize: 16, textAlign: 'center', color: Colors.fontColorOnBackground, margin: 20 }}>
                            Ainda não temos nenhum tópico neste fórum!
                        </Text>


                }

                <FlatList
                    contentContainerStyle={{ width: 600, marginTop: 12 }}
                    data={this.state.topics}
                    renderItem={({item}) => {
                        return <TopicRender data={item} />
                    }}
                    refreshControl={
                        <RefreshControl
                            refreshing={this.state.isFetchingTopics}
                            onRefresh={() => this.queryTopics()}
                            colors={[Colors.spinnerColor]}
                            title={'Carregando tópicos'}
                        />
                    }
                    keyExtractor={item => item.topicId.toString()}
                />

            </NavBar>
        )
    }

}

const mapStateToProps = state => {
    return {
        journeyId: state.journey.currentJourney === null ? null : state.journey.currentJourney.id
    }
}

export default connect(mapStateToProps)(ForumScreen);
